export default "__VITE_ASSET__pcwrW3Lu__"